module.exports = __webpack_public_path__ + "img/Email-Icon.63c61e85.svg";